<div
  class="pointer-events-auto flex h-fit w-fit flex-col items-center gap-1 rounded-lg text-sm drop-shadow-lg [&>button]:h-7 [&>button]:w-7">
  @if (tableData().confirmed()) {
    <button
      class="bg-theme-blue flex items-center justify-center rounded-md text-white"
      (click)="editButtonClicked.emit(); $event.stopImmediatePropagation()"
      (mousedown)="$event.stopPropagation()"
      (mouseup)="$event.stopPropagation()">
      <span class="material-icons" style="transform: scale(0.8)">edit</span>
    </button>
  } @else if (!tableData().layoutDefined()) {
    <button
      class="flex items-center justify-center rounded-md bg-pink-500"
      data-testid="table-overlay-magic-wand-button"
      (click)="magicWandButtonClicked.emit(); $event.stopImmediatePropagation()"
      (mousedown)="$event.stopPropagation()"
      (mouseup)="$event.stopPropagation()">
      <img
        class="scale-90"
        src="../../../../../assets/icons/magic-wand.svg"
        loading="lazy"
        alt="" />
    </button>
  }
  <button
    class="bg-danger flex items-center justify-center rounded-md text-white"
    data-testid="table-overlay-delete-button"
    (click)="deleteButtonClicked.emit(); $event.stopPropagation()"
    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
    (mouseup)="$event.stopPropagation()">
    <span class="material-icons scale-90">close</span>
  </button>
</div>
